<template>
	<device-widget name="Thermostat" :node="node">
		<template #status>{{ temperature }}</template>
		<template #sub-status>
			<template v-if="variables.mode === 'off'">Off</template>
			<template v-else-if="smartModeTemp">
				<span class="magic">{{ smartModeTemp }}</span>
			</template>
			<template v-else>
				<span class="heat">{{ variables.heat }}</span> /
				<span class="cool">{{ variables.cool }}</span>
			</template>
		</template>
	</device-widget>
</template>

<style lang="scss" scoped>
.heat {
	color: var(--v-rust-red-base);
}

.cool {
	color: var(--v-ocean-lighten1);
}

.magic {
	color: purple;
}
</style>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import DeviceWidget from "../../../shared/DeviceWidget";

export default {
	components: { DeviceWidget },

	props: {
		node: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapGetters({
			smartModeSettings: "controller/nodes/smartModeSettings",
		}),

		variables() {
			return this.node.variables;
		},

		temperature() {
			const temp = this.variables.temp;
			return (_.isNil(temp) ? "--" : temp) + "°";
		},

		smartModeTemp() {
			const guid = this.node.meta.guid;
			const settings = _.get(this.smartModeSettings, guid);
			if (settings && settings.active) return settings.temperature;
			return false;
		},
	},
};
</script>
